import { useSelector } from 'react-redux'

export const useAppConfig = () =>
    useSelector(
        (state) => state.appReducer && state.appReducer.appConfig,
        () => {}
    )

export const useLanguage = () =>
    useSelector(
        (state) => state.appReducer.language,
        () => {}
    )
